__webpack_require__.O(0, ["common"], () => {
	__webpack_require__.E("resources_src_lib_fontawesome_css_fontawesome_min_css-_b5d9");
	__webpack_require__.E("fontawesome");
}, 5);